import React from 'react';
import { Link } from 'react-router-dom';
import { FuelerIcon, Text } from './components';
import styled from 'styled-components';
import OnlineStatus from './OnlineStatus';

const UnorderedListContainer = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

const NavListItem = styled.li`
    width: 100%;
    display: flex;
    margin: 0;
    border-top: 1px solid ${props => props.theme.primaryTextColor};
    border-bottom: 1px solid ${props => props.theme.primaryTextColor};
    background: ${props => props.theme.secondaryBackgroundColor};
`;

const NavLink = styled(Link)`
    color: ${props => props.theme.primaryTextColor};
    text-decoration: none;
`;

const LogoutIcon = styled(FuelerIcon)`
    margin: auto 20px;
`;

const NavText = Text.extend`
    margin-left: 20px;
`;

const AppNavigation = ({ online }) => {
    return (
        <UnorderedListContainer>
            <NavLink to="/logout">
                <NavListItem>
                    <NavText>Logout</NavText>
                    <LogoutIcon fill="#fff" icon="logout" />
                </NavListItem>
            </NavLink>
            <OnlineStatus online={online} />
        </UnorderedListContainer>
    );
};

export default AppNavigation;



// WEBPACK FOOTER //
// ./src/AppNavigation.js